import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { MathEnabledTextComponent, getSize } from '@lib/common';
import styled, { getColor } from '@xstyled/styled-components';
import { Select } from 'antd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Option = Select.Option;
var StyledAnswerItemLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  padding: ", " ", ";\n\n  border: 1px solid ", ";\n\n  background-color: #faf8fc;\n\n  border-radius: ", ";\n"])), getSize('padding8'), getSize('padding8'), getSize('padding12'), function (_ref) {
  var $isSelected = _ref.$isSelected;
  return $isSelected ? getColor('fillIntActive') : '#cbd5e1';
}, getSize('radiusSm'));
var StyledIndexPrefix = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: #334155;\n  flex-shrink: 0;\n\n  min-width: 28px;\n\n  text-align: center;\n"])), getSize('typo14'));
var StyledSelectWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 200px;\n  flex-shrink: 0;\n\n  .ant-select {\n    width: 100%;\n  }\n\n  .ant-select-selector {\n    min-height: 36px;\n    height: auto !important;\n    padding: ", " ", " !important;\n    border: 1px solid #cbd5e1 !important;\n    border-radius: ", " !important;\n    background-color: #ffffff !important;\n    box-shadow: none !important;\n\n    &:hover {\n      border-color: #cbd5e1 !important;\n    }\n  }\n\n  .ant-select-focused .ant-select-selector {\n    border-color: ", " !important;\n    box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.1) !important;\n  }\n\n  .ant-select-selection-placeholder {\n    color: #94a3b8;\n    font-size: ", ";\n    line-height: 1.5;\n  }\n\n  .ant-select-selection-item {\n    white-space: normal;\n    word-wrap: break-word;\n    line-height: 1.5;\n    padding: 0;\n    color: #334155;\n    font-size: ", ";\n  }\n\n  .ant-select-arrow {\n    color: #64748b;\n  }\n\n  // Style cho dropdown options\n  .ant-select-dropdown {\n    border-radius: ", ";\n    box-shadow:\n      0 4px 6px -1px rgba(0, 0, 0, 0.1),\n      0 2px 4px -1px rgba(0, 0, 0, 0.06);\n\n    .ant-select-item {\n      white-space: normal;\n      word-wrap: break-word;\n      padding: ", " ", ";\n      line-height: 1.5;\n      color: #334155;\n      font-size: ", ";\n    }\n\n    .ant-select-item-option-selected {\n      background-color: #faf8fc;\n      color: ", ";\n      font-weight: 500;\n    }\n\n    .ant-select-item-option-active {\n      background-color: #f8fafc;\n    }\n\n    .ant-select-item-option-content {\n      white-space: normal;\n      word-wrap: break-word;\n    }\n  }\n"])), getSize('padding8'), getSize('padding12'), getSize('radiusSm'), getColor('fillIntActive'), getSize('typo14'), getSize('typo14'), getSize('radiusSm'), getSize('padding8'), getSize('padding12'), getSize('typo14'), getColor('fillIntActive'));
var StyledSubQuestionDescription = styled(MathEnabledTextComponent)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n  color: #334155;\n  line-height: ", ";\n  flex: 1;\n\n  p {\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"])), getSize('typo14'), getSize('padding20'));
export var AnswerItem = function AnswerItem(_ref2) {
  var index = _ref2.index,
      isSelected = _ref2.isSelected,
      readonly = _ref2.readonly,
      subQuestionDescription = _ref2.subQuestionDescription,
      correctAnswerId = _ref2.correctAnswerId,
      selectedValue = _ref2.selectedValue,
      onSelect = _ref2.onSelect,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      isShowCorrectAnswer = _ref2.isShowCorrectAnswer;
  return /*#__PURE__*/_jsxs(StyledAnswerItemLayout, {
    $isSelected: isSelected,
    children: [/*#__PURE__*/_jsxs(StyledIndexPrefix, {
      children: [index, "."]
    }), /*#__PURE__*/_jsx(StyledSelectWrapper, {
      children: /*#__PURE__*/_jsx(Select, {
        value: isShowCorrectAnswer ? correctAnswerId : selectedValue,
        onChange: onSelect,
        disabled: readonly,
        placeholder: "Select answer...",
        style: {
          width: '100%'
        },
        dropdownStyle: {
          maxWidth: '400px'
        },
        optionLabelProp: "label",
        children: options.map(function (option) {
          return /*#__PURE__*/_jsx(Option, {
            value: option.value,
            label: option.label,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                lineHeight: '1.5'
              },
              children: option.label
            })
          }, option.value);
        })
      })
    }), subQuestionDescription && /*#__PURE__*/_jsx(StyledSubQuestionDescription, {
      value: subQuestionDescription
    })]
  });
};